import { Component, Input, OnInit } from '@angular/core';

import { AmorphicService } from '../../../../../../../coverpath-common/angular/services/amorphic/amorphic.service';
import { QuoteCardService } from '../quote-card.service';
import { QuoteCardTextDescriptionComponent } from '../quote-card-text-description/quote-card-text-description.component';

@Component({
  moduleId: module.id,
  selector: 'quote-card-conversion-text-description',
  templateUrl: './quote-card-conversion-text-description.component.html',
})
export class QuoteCardConversionTextDescriptionComponent extends QuoteCardTextDescriptionComponent implements OnInit {
  constructor(protected amorphicService: AmorphicService, protected quoteCardService: QuoteCardService) {
    super(amorphicService, quoteCardService);
  }
}
